import { formatPriceByStoreLocale } from 'lib/shopify';
import useAddonDiscount from 'hooks/shop/useAddonDiscount';
import styles from './productAddon.module.scss';

const ProductAddon = ({ productData, locale, addonConfigs, onToggle, selections }) => {
  const { eligibleAddons } = useAddonDiscount(
    addonConfigs,
    locale,
    productData?.shopifyData
  );

  if (!eligibleAddons.length) return null;

  return eligibleAddons.map(addon => {
    const { checkboxLabel, fullPrice, salePrice, variantId } = addon;
    const checked = !!selections[variantId];

    return (
      <div key={variantId} className={styles.addonWrapper}>
        <label className={styles.addonLabel} htmlFor={`addon-checkbox-${variantId}`}>
          <span className={styles.checkbox}>
            <input
              id={`addon-checkbox-${variantId}`}
              type="checkbox"
              checked={checked}
              onChange={e => onToggle(variantId, e.target.checked)}
            />
            <span className={styles.checkmark} />
          </span>
          <span className={styles.labelText}>
            {checkboxLabel}
            {fullPrice && (
              <span className={styles.priceInfo}>
                {' (+ '}
                {salePrice && (
                  <span className={styles.salePrice}>
                    {formatPriceByStoreLocale({ locale, price: salePrice })}
                  </span>
                )}
                {salePrice ? (
                  <span className={styles.compareAtPrice}>
                    {formatPriceByStoreLocale({ locale, price: fullPrice })}
                  </span>
                ) : (
                  <span>{formatPriceByStoreLocale({ locale, price: fullPrice })}</span>
                )}
                {')'}
              </span>
            )}
          </span>
        </label>
        <div className={styles.divider} />
      </div>
    );
  });
};

export default ProductAddon;
